import { cn } from '@/lib/utils';
import { QUOTE_SIGNALS, SIGNAL_HINTS, SIGNAL_LABELS, type QuoteSignal } from './quoteSignals';

/**
 * 'Vraagt actie' staat bewust boven de filterbalk en los van de statustabs: het
 * is een werkvoorraad die dwars door de statussen loopt. Eén actief signaal
 * tegelijk, want twee tegelijk levert vrijwel altijd een lege lijst op.
 */
export function QuoteSignalFilters({
  counts,
  active,
  onChange,
}: {
  counts: Record<QuoteSignal, number>;
  active: QuoteSignal | null;
  onChange: (signal: QuoteSignal | null) => void;
}) {
  const visible = QUOTE_SIGNALS.filter((signal) => counts[signal] > 0 || active === signal);
  if (visible.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
        Vraagt actie
      </span>
      {visible.map((signal) => {
        const isActive = active === signal;
        return (
          <button
            key={signal}
            type="button"
            title={SIGNAL_HINTS[signal]}
            aria-pressed={isActive}
            onClick={() => onChange(isActive ? null : signal)}
            className={cn(
              'inline-flex h-8 items-center gap-2 rounded-full px-3 text-[13px] transition-colors',
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-foreground hover:bg-accent',
            )}
          >
            {SIGNAL_LABELS[signal]}
            <span className={cn('text-xs font-semibold', isActive ? 'text-primary-foreground' : 'text-muted-foreground')}>
              {counts[signal]}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default QuoteSignalFilters;
